import { z } from 'zod';
import { Campaign } from './Campaign';

export const campaignListExample = z.array(Campaign).parse([
  // 50個分のデータを作る。createdAt, updatedAtは1日ずつずらす。
  ...Array.from({ length: 50 }, (_, i) => ({
    id: `campaign-${i}`,
    locationId: 'location-0',
    name: `キャンペーン ${i}`,
    hashTag: `campaign:${i}`,
    description: `キャンペーン ${i} の説明`,
    eyeCatchURL: `https://picsum.photos/seed/campaign${i}/200`,
    bannerURL: `https://picsum.photos/seed/campaign${i}/400/200`,
    draft: i % 4 === 0,
    startDate: new Date(Date.UTC(2021, 1, 1 + i, 0, 0, 0, 0)).toISOString(),
    endDate: new Date(Date.UTC(2021, 1, 1 + i + 1, 0, 0, 0, 0)).toISOString(),
    createdAt: new Date(Date.UTC(2021, 1, 1 + i, 0, 0, 0, 0)).toISOString(),
    updatedAt: new Date(Date.UTC(2021, 1, 1 + i, 0, 0, 0, 0)).toISOString(),
    publishedAt: new Date(Date.UTC(2021, 1, 1 + i, 0, 0, 0, 0)).toISOString(),
  })),
]);
